const DISCONNECTED = 'DISCONNECTED';
const CONTACTING_TEXT = 'Contacting...';

class PaymentTerminalConfig implements MerchantosPaymentTerminalConfig {
  // @ts-expect-error ts-migrate(2564) FIXME: Property '_shopID' has no initializer and is not d... Remove this comment to see the full error message
  _shopID: MerchantosPaymentTerminalConfig['_shopID'];

  private getTerminalRow = (row: string) => {
    return $(`#admin_listings_credit_card_terminals_view_r_${row}`);
  };

  // -------------------------PUBLIC METHODS --------------------------//

  /**
   * Called whenever the terminal configuration listing is refreshed.
   *
   * @param shopID {Number} The shop ID of the terminals to monitor
   * @private
   */
  onRefresh: MerchantosPaymentTerminalConfig['onRefresh'] = (shopID) => {
    // store the shop
    this._shopID = shopID;
  };

  checkTerminalStatus: MerchantosPaymentTerminalConfig['checkTerminalStatus'] = (row) => {
    const $terminalRow = this.getTerminalRow(row);
    const name = $terminalRow.find(`#cellCreditCardTerminalsName_${row} input`).val();
    const $status = $terminalRow.find(`#cellCreditCardTerminalsStatus_${row}`);

    // refresh the terminal data
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.payments.getAllTerminals(true).done(() =>
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.payments.getTerminal(name, this._shopID).done((terminal: TSFixMe) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
        const provider = window.merchantos.payments.addProvider(
          'Genius',
          terminal.name,
          this._shopID,
          0, // we don't really care what the gateway is for this check
          terminal
        );

        $status.text(CONTACTING_TEXT);
        provider
          .checkStatus()
          .done((response: TSFixMe) => {
            $status.text(response.Status);
          })
          .fail(() => {
            $status.text(DISCONNECTED);
          })
          .always(() => {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
            window.merchantos.payments.removeProvider(terminal.name, this._shopID);
          });
      })
    );
  };
}

window.merchantos.settings = {
  payment_terminal_config: new PaymentTerminalConfig(),
};
